<template>
    <RentalsListingsShell>

        <CardShell>
            <!-- heading -->
            <BackLinkHeading linkText="My Rentals & Listings" text="Rental History" route="/rentals-listings-mobile"/>

            <HugeSpinner v-if="loadingHistoricRentals"/>
            <div v-else>
                
                <EmptyCard v-if="historicRentals.length === 0" 
                    class="w-75 pv5"
                    :image="require(`@/assets/img/graphic_calendar.svg`)"
                    description="You havn't made any rentals yet."
                    buttonText="Search for tools & equipment"
                    route="search?q="
                />
                
                <RentalsList v-else :rentals="historicRentals" />
                
            </div>

            

        </CardShell>

    </RentalsListingsShell>
</template>

<script>
import RentalsListingsShell from '@/components/rentalsListings/shared/RentalsListingsShell.vue';
import CardShell from '@/components/global/CardShell.vue';
import BackLinkHeading from '@/components/controls/BackLinkHeading.vue';
import EmptyCard from '@/components/global/EmptyCard.vue';
import RentalsList from '@/components/rentalsListings/rentalHistory/RentalsList.vue';
import HugeSpinner from '@/components/controls/HugeSpinner.vue';
import { mapActions, mapState } from 'vuex';

export default {
    components: {
        RentalsListingsShell,
        CardShell,
        BackLinkHeading,
        EmptyCard,
        RentalsList,
        HugeSpinner
    },
    computed: {
        ...mapState('rentals', ['historicRentals', 'loadingHistoricRentals'])
    },
    methods: {
        ...mapActions('rentals', ['getHistoricRentals'])
    },
    created: function() {
        this.getHistoricRentals();
    }
};
</script>
